import axios from "axios";
import Config from "../../config/index";

import {
  CREATE_DYNAMIC_COLUMN_FAILURE,
  CREATE_DYNAMIC_COLUMN_REQUEST,
  CREATE_DYNAMIC_COLUMN_SUCCESS,
  GET_DYNAMIC_COLUMN_FAILURE,
  GET_DYNAMIC_COLUMN_REQUEST,
  GET_DYNAMIC_COLUMN_SUCCESS,
} from "./dynamicColumnTypes";

let baseUrl = Config.baseUrl;

const getDynamicColumnRequest = () => {
  return {
    type: GET_DYNAMIC_COLUMN_REQUEST,
  };
};

const getDynamicColumnSuccess = (payload) => {
  return {
    type: GET_DYNAMIC_COLUMN_SUCCESS,
    payload: payload,
  };
};

const getDynamicColumnFailure = (error) => {
  return {
    type: GET_DYNAMIC_COLUMN_FAILURE,
    payload: error,
  };
};

const getDynamicColumn = (userId, subModuleId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDynamicColumnRequest());
    let url = `${baseUrl}/fieldMapping/by_user_page?userId=${userId}&subModuleId=${subModuleId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDynamicColumnSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDynamicColumnFailure(err.message));
      });
  };
};

const createDynamicColumnRequest = () => {
  return {
    type: CREATE_DYNAMIC_COLUMN_REQUEST,
  };
};

const createDynamicColumnSuccess = (payload) => {
  return {
    type: CREATE_DYNAMIC_COLUMN_SUCCESS,
    payload: payload,
  };
};

const createDynamicColumnFailure = (error) => {
  return {
    type: CREATE_DYNAMIC_COLUMN_FAILURE,
    payload: error,
  };
};

const createDynamicColumn = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createDynamicColumnRequest());
    let url = `${baseUrl}/fieldMapping`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createDynamicColumnSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createDynamicColumnFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export { getDynamicColumn, createDynamicColumn };
